import PropTypes from 'prop-types';

import { LayoutContainer as ContainerQueryLayoutContainer } from './container-query/layout-container';
import { LayoutContainer as ResizeObserverLayoutContainer } from './resize-observer-fallback/layout-container';
import { doesBrowserSupportContainerQuery } from '../../../../services/browser-support-service';

/**
 * @param {object} props
 * @param {React.ReactNode} props.addressColumnContent - The content to be rendered in the address column of the layout.
 * @param {React.ReactNode} props.rmaColumnContent - The content to be rendered in the RMA column of the layout.
 * @param {React.ReactNode} props.costSummaryColumnContent - The content to be rendered in the cost summary column of the layout.
 * @returns {JSX.Element} The appropriate layout container based on browser support for container queries.
 */
export const EnhancedReturnDetailsLayoutLoader = (props) => {
  if (doesBrowserSupportContainerQuery) {
    return <ContainerQueryLayoutContainer {...props} />;
  }

  return <ResizeObserverLayoutContainer {...props} />;
};

EnhancedReturnDetailsLayoutLoader.propTypes = {
  addressColumnContent: PropTypes.node.isRequired,
  rmaColumnContent: PropTypes.node.isRequired,
  costSummaryColumnContent: PropTypes.node.isRequired,
};
